import Modal from "common/Modal/Modal";
import React, { useEffect } from "react";
import { useRouteMatch } from "react-router-dom";
import { SIGNAL_EXTRA_DETAILS_PATH } from "common/constants";
import { getRouteWithoutPath } from "utils/routes";
import Text from "common/Typography/Text";
import useHistoryWithQuery from "utils/hooks/useHistoryWithQuery";
import { displayResultMessage } from "utils/misc";
import { sharedLib } from "@shared/services/shared.service";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

interface CancelSignalModalProps {
  signalId: number;
  closeModal: () => void;
  visible: boolean;
}

const CancelSignalModal = ({
  signalId,
  closeModal,
  visible,
}: CancelSignalModalProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.SIGNALS);
  const { historyPush } = useHistoryWithQuery();
  const signalsExtraDetailsMatch = Boolean(
    useRouteMatch(SIGNAL_EXTRA_DETAILS_PATH)
  );
  const [cancelSignal, { isLoading, isSuccess }] =
    sharedLib.sharedApi.signals.useCancelSignalMutation();

  const onCancelSignal = () => {
    displayResultMessage(cancelSignal({ signal_id: signalId }).unwrap()).catch(
      () => {}
    );
  };

  useEffect(() => {
    if (isSuccess) {
      closeModal();
      if (signalsExtraDetailsMatch) {
        historyPush(
          getRouteWithoutPath(location.pathname, SIGNAL_EXTRA_DETAILS_PATH)
        );
      }
    }
  }, [isSuccess]);

  return (
    <Modal
      onCancel={closeModal}
      open={visible}
      title={t("modals.close_signal.title")}
      onOk={onCancelSignal}
      okButtonProps={{ loading: isLoading }}
    >
      <Text>{t("modals.close_signal.message")}</Text>
    </Modal>
  );
};

export default CancelSignalModal;
